import { render, staticRenderFns } from "./CompetitorsResults.vue?vue&type=template&id=498cf4c1&"
import script from "./CompetitorsResults.vue?vue&type=script&lang=js&"
export * from "./CompetitorsResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports